package co.maytes.standupbot.dashboard.pages.ds

import androidx.compose.runtime.Composable
import co.maytes.standupbot.dashboard.features.ds.DesignSystemGallery
import com.varabyte.kobweb.core.Page

@Page("/ds")
@Composable
fun DesignSystemPage() {
    DesignSystemGallery()
}
